import React, { useEffect, useState, useRef, useMemo,useContext } from "react";
import {  Combobox, Option, Button, Spinner, Accordion, AccordionItem, AccordionHeader, AccordionPanel, Text,Link } from '@fluentui/react-components';
import { ComboBox } from '@fluentui/react';

import { ArrowClockwiseRegular,ChevronRight20Regular } from "@fluentui/react-icons";
import * as microsoftTeams from '@microsoft/teams-js';
import { Icon } from '@fluentui/react';
// import "../../../index.css";
import "../index.css";
import { Loader } from '@fluentui/react-northstar';
import { TeamsFxContext } from "./Context";

export const MenuListWithNestedSubmenus = ({data =[], onSelect}) => {
  //const styles = useMenuListContainerStyles();
  const {userPrincipalName} = useContext(TeamsFxContext);
  const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;
  const sn_api_countryURL = `${reactFunctionEndpoint}/api/getServiceNowAPIData?type=countrylist`;
  const sn_api_orgURL = `${reactFunctionEndpoint}/api/getServiceNowAPIData?type=supportorglist&inputvalue=`;
  const sn_api_actionURL = `${reactFunctionEndpoint}/api/getServiceNowAPIData?type=actionlist&inputvalue=`;
  const sn_api_itcontactsurl = `${reactFunctionEndpoint}/api/getServiceNowAPIData?type=itcontacts`;
  const itcontact_sd_email = `${reactFunctionEndpoint}/api/getSettings?type=sdemail`;
  const [accessToken, setAccessToken] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [filteredCountryList, setFilteredCountryList]= useState([]);
  const [selectedCountry, setSelectedCountry] = useState("Global");
  const [globalContactDetails_Raw, setGlobalContactDetails_Raw] = useState([]);
  const [itContactDetails, setItContactDetails] = useState([]);
  const [itContactDetails_raw, setItContactDetails_raw] = useState([]);
  const [filteredContactDetails, setFilteredContactDetails] = useState([]);
  const [globalContactDetails, setGlobalContactDetails] = useState([]);
  const [globalContactAvailable,setGlobalContactAvailable] = useState(false);
  const [orgItems, setOrgItems] = useState([]);
  const [globalData, setGlobalData] = useState([]);
  const [actionItems, setActionItems] = useState([]);
  const [serviceDeskEmail,setServiceDeskEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const comboRef = useRef(null);
  const [inputText, setInputText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [previousValue, setPreviousValue] = useState("");

  //useEffect(()=> {

    
    // const initializaAndFetch = async () => {
    //   await microsoftTeams.initialize();
    //   const token = await microsoftTeams.authentication.getAuthToken();
    //   console.log("Auth token : ", token);
    //   setAccessToken(token);
    // } 
   
   
   /*  microsoftTeams.app.initialize().then(()=>{
    microsoftTeams.authentication
    .getAuthToken()
    .then((result)=>{
      setAccessToken(result);
    })
    .catch((err)=>console.error("Token fetch failed: ", err)); */

  //});
  //},[]);

  useEffect(()=> {
    microsoftTeams.app.initialize().then(()=>{
    microsoftTeams.authentication
    .getAuthToken()
    .then((result)=>{
      setAccessToken(result);
    })
    .catch((err)=>console.error("Token fetch failed: ", err));

  });
  },[]);

  //Fetch dropdown options once token is ready
  useEffect(()=>{
    if(!accessToken) return;
    const sn_api_regionalContactInfo = `${reactFunctionEndpoint}/api/getServiceNowAPIData?type=contacts&inputvalue=${encodeURIComponent(userPrincipalName)}`;

    const fetchCountries = async()=>{
      try{
        const [globalContactResponse, countryResponse, itContactResponse, sdEmailResponse] = await Promise.all([
          fetch(sn_api_regionalContactInfo,
            {method: "GET", headers: {"Content-Type": "application/json",Authorization:`Bearer ${accessToken}`}}
          ),
          fetch(sn_api_countryURL,{method: "GET",headers: {"Content-Type": "application/json",Authorization: `Bearer ${accessToken}`}}),
          fetch(sn_api_countryURL,{method: "GET",headers: {"Content-Type": "application/json",Authorization: `Bearer ${accessToken}`,},}),
          fetch(itcontact_sd_email,{method: "GET",headers: {"Content-Type": "application/json",Authorization: `Bearer ${accessToken}`,},}),
        ]);

        const resp_globalContactDetails = await globalContactResponse.json();
        const resp_country = await countryResponse.json();
        const resp_itcontacts = await itContactResponse.json();
        const resp_sdemail = await sdEmailResponse.json();

        let api2Row = resp_globalContactDetails;
        if(Array.isArray(resp_globalContactDetails)){
          api2Row = resp_globalContactDetails[0];
        } else if (resp_globalContactDetails.value){
          api2Row = resp_globalContactDetails.value[0];
        } else if(resp_globalContactDetails.data){
          api2Row = resp_globalContactDetails.data;
        }
        
        console.log("Contact response: ", api2Row);
        setGlobalContactDetails(api2Row);

        //setItContactDetails(resp_itcontacts);
        filteritContactDetails(resp_itcontacts,"Global");
        setServiceDeskEmail(resp_sdemail.urlPath);


        //Map to combobox format and sort alphabetically
        const replaceSpecialCharacters = (text) => {
          return text.replace(/ï¿½/g, 'Å');
        };
        
        //const extracted = extractArrayFromData(resp_result);  
        //console.log(`Country data  response from servicenow ${resp_result}`);
        // Map through the data to correct special characters and create an array of objects
        const countryData = resp_country.map(item => ({
          key: replaceSpecialCharacters(item.countryID),
          text: replaceSpecialCharacters(item.countryName)
        }));
        //console.log(`Country data  response  ${countryData}`);

        const seen = new Set();
        const uniqueCountryData = countryData.filter(item => {
          if (seen.has(item.key)) {
            return false;
          } else {
            seen.add(item.key);
            return true;
          }
        });

        const countryData_sorted = uniqueCountryData.sort((a, b) => a.text.localeCompare(b.text));

        setCountryList(countryData_sorted || []); // Ensure `countryList` is always an array
        //mergeGlobalContactDetails(resp_globalContactDetails);
        setFilteredCountryList(countryData_sorted); // Initially, filtered list is the same as the full list
        
        const mergeGlobalContactDetails = resp_itcontacts.map(
          item =>{console.log("Comparing:", item.countryName,"Global");
            if(item.countryName === "Global") {
              setGlobalContactAvailable(true);
              console.log("Match found", item.countryName);
              return {
                ...item,
                internalNumber:api2Row.extension ?? item.internalNumber ?? "",
                internationalNumber:api2Row.international ?? item.internationalNumber ?? "",
                internationalNumbertTollfree:api2Row.local ?? item.internationalNumbertTollfree ?? ""
              };
           
          }
          return item;
        }
        );
        setItContactDetails(mergeGlobalContactDetails);
        console.log("merged data: ", mergeGlobalContactDetails);

        setInputText("Global")
        setSelectedCountry("Global");
        setPreviousValue("Global");

        console.log("Country data: ", uniqueCountryData);
        console.log("Sorted Country data: ", countryData_sorted);
        
        //Find and set Global Details
        const global = countryData_sorted.find((opt) => opt.text.toLowerCase() === "global");
        //setSelectedCountry(global);
      } catch (err){
        console.error("Error fetching country: ", err);
      }
    };
    fetchCountries();
  },[accessToken]);
/* 
  useEffect(()=>{
    const v = (inputText || "").toLowerCase();
    if(!v){
      setFilteredCountryList(countryList);
      return;
    }

    const filtered = countryList.filter((o)=> 
    o.text.toLowerCase().startsWith(v));
    setFilteredCountryList(filtered);
  },[inputText, countryList]); */

  const filteritContactDetails = (contactDetails,name)=>{
    const match = contactDetails.find((d)=>d.countryName === name);
    setFilteredContactDetails(match || null);
    console.log("Match details: ", match);
  };

  //Fetch org details for selected and global
  useEffect(()=> {
    if(!accessToken ||!countryList.length) return;

    const fetchData = async()=>{
      setIsLoading(true);
      try{
        //always fetch global first
        const global = countryList.find((opt)=>opt.text.toLowerCase()==="global");

        const [globalRes, selectedRes] = await Promise.all([fetch(`${sn_api_orgURL}${global.key}`,
          {
              method: "GET",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`,
              },
          }),
          
        selectedCountry && selectedCountry.text !== "Global" ? fetch(`${sn_api_orgURL}${selectedCountry.key}`,
          {
              method: "GET",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`,
              },
          }): Promise.resolve({json: async()=>[]}),
        
        ]);

        const global_Data = await globalRes.json();
        const selectedData = await selectedRes.json();

        setGlobalData(Array.isArray(global_Data) && global_Data[0]?.statusCode === "404" ? [] : global_Data);
        setOrgItems(Array.isArray(selectedData) && selectedData[0]?.statusCode === "404" ? [] : selectedData);
        console.log("selected country: ", selectedCountry.text);
        
        filteritContactDetails(itContactDetails, selectedCountry.text);
        //console.log("value of filtered it contact details: ", filteredContactDetails); 


        /* const [selectedRes] = await Promise.all([
          
        selectedCountry && selectedCountry.text !== "Global" ? fetch(`${sn_api_orgURL}${selectedCountry.key}`,
          {
              method: "GET",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`,
              },
          }): Promise.resolve({json: async()=>[]}),
        
        ]);

        const selectedData = await selectedRes.json();

        setOrgItems(Array.isArray(selectedData) && selectedData[0]?.statusCode === "404" ? [] : selectedData);
        console.log("selected country: ", selectedCountry.text);

        filteritContactDetails(itContactDetails, selectedCountry.text);
        console.log("value of filtered it contact details: ", filteredContactDetails); */


      } catch (err){
        console.error("Error fetching country: ", err);
        setOrgItems([]);
      } finally {
        setIsLoading (false);
      }
    };
    fetchData();
  },[selectedCountry, countryList, accessToken, filteredContactDetails]);

  //Fetch subOrg - action details on expansion
  const handleSubOrgFetch = async(orgId) => {
    if(actionItems[orgId]) return; //already found
    setActionLoading(orgId);

    try{
      const res = await fetch(`${sn_api_actionURL}${orgId}`,
          {
              method: "GET",
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`,
              },
          });
      const data = await res.json();

      if (Array.isArray(data) && data[0]?.statusCode === "404" ){
        setActionItems((prev)=>({...prev,[orgId]:[]}));
      } else {
        setActionItems((prev) => ({...prev,[orgId]: data}));
      }
    } catch (err) {
      console.err("Error fetching action items details: ", err);
    } finally {
      setActionLoading(null);
    }
  };

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleOptionSelect = (_,data)=>{
    console.log("data under handle option select:", data);

    const chosen = data.optionText;
    const selectedObj = countryList.find((item)=>item.text === chosen);

    if(selectedObj){
      setSelectedCountry(selectedObj || { key:"custom", text: data.optionText});
      console.log("selected country in handleoptionselect selectedobj: ", selectedObj);
      setInputText(selectedObj.text);
      console.log("selected country in handleoptionselect selectedobj.countryName: ", selectedObj.text);
      setPreviousValue(selectedObj.text);
      
      if(typeof onSelect === "function"){
        onSelect(selectedObj);
      }
    } else{
      setInputText(chosen);

      if (data.optionText & data.optionText!=="") {
        setSelectedCountry({ key:"custom", text: data.optionText});
      } else {
        setSelectedCountry("Global");
      }
      
      setPreviousValue(chosen);
    }
    console.log("selected country in handleoptionselect: ", chosen);
  };

  //Render loading state
  //if(isLoading) return<Spinner label="Loading... "/>

  const handleCountryChange = (_, data) => {
    setInputText(data.value || '');
    const selectedValue = countryList.filter((opt)=> opt.countryName.toLowerCase().includes(data.value.toLowerCase()));
    setSelectedCountry({key:"custom",text: data.value})
    setFilteredCountryList(selectedValue);
  };

  const customStyles = {
    optionsContainer: {
        maxHeight: '200px',  // Adjust the height of the dropdown container
    },
    
    optionText: {
        height: '20px',  // Adjust height for each dropdown item
        lineHeight: '20px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    root: {
        height: '32px',  // Adjust the height of the ComboBox input
        maxWidth: 205,  // Optional: Control the overall width                                
    },
    input: {
        height: '32px',  // Adjust the height of the text input field
        lineHeight: '32px',
        padding: '0 8px',
    }
  };    

  const onRenderOption = (option) => (
    <div style={{ height: '25px', lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <span>{option.text}</span>
    <Icon
        //iconName="ChevronDown"
        aria-hidden={false}
        style={{
            fontSize: '30px',  // Adjust the size of the icon
            //color: 'red',  // Fluent UI default blue color or any color you want
            marginLeft: '8px', // Space between text and icon
        }}
    />
   </div>
  );

  const handleFocus = () => {
    setPreviousValue(inputText);
    setInputText("");
  };

  const handleBlur = () => {
    setInputText(previousValue);
    setFilteredCountryList(countryList);
  };

  //const globalContactAvailable = globalContactDetails.length>0;

//flex gap-2 items-center my-3 flex-wrap //custom-combobox
  return (
      <div className="p-4 max-w-lg mx-auto">
        <Text weight = "semibold" size={300}> Override location </Text>
        {/* Dropdown selector */}
        <div className="custom-combobox">
          <Combobox style={{marginBottom: "16px"}}
            placeholder="Select or search country"
            freeform
            value={inputText}
            onFocus={handleFocus}
            onChange = {handleCountryChange}
            onOptionSelect={handleOptionSelect}
            onBlur={handleBlur}
            styles={customStyles}
            autoComplete="on"
          >
            {filteredCountryList.map((opt)=> (
              <Option key={opt.key} text={opt.text}>{opt.text}</Option>
            ))}

          </Combobox>

          {/*<Button appearance = "secondary" onClick={()=>setSelectedCountry(countryList.find((o)=>o.text.toLowerCase() === "global"))}> Refresh </Button> */}
      </div>
        
      {selectedCountry?.text && selectedCountry.text.toLowerCase() !=="global" && (
        <Text weight = "semibold" style={{fontSize:"13px",marginBottom: "16px"}}>Selected Country: {selectedCountry.text} <br /> </Text>
      )}

       {/* Display IT Contact for the selected country */}
      <div className="mt-2" style={{marginBottom: "16px"}}>
        <Text style = {{fontWeight:500, fontSize: "13px"}}>Contact us 24/7:</Text>
        <br />
        {filteredContactDetails ? (
          <>
          <div style={{fontSize:"13px",lineHeight: "1.5",fontWeight:300, marginBottom: "13px"}}>
            <div> Extension: {filteredContactDetails.internalNumber} </div>
            <div> Local: {filteredContactDetails.internationalNumber} </div>
            <div> International: {filteredContactDetails.internationalNumbertTollfree} </div>
            <div> Service Desk: {serviceDeskEmail} </div>
          </div>
          </>
        ):
        (globalContactAvailable ? (
        <>
          <div style={{fontSize:"13px",lineHeight: "1.5",fontWeight:300, marginBottom: "13px"}}>
            <Text weight = "bold" style = {{fontWeight:300, fontSize: "13px"}}> Regional contact details </Text>
            <br />
            <div> Extension: {globalContactDetails.extension} </div>
            <div> Local: {globalContactDetails.local} </div>
            <div> International: {globalContactDetails.international} </div>
            <div> Service Desk: {serviceDeskEmail} </div>
          </div>
        </>):(<Text style={{fontWeight:300, fontSize: "13px" , marginBottom: "13px"}}> No contact details available for the selected country</Text>))}
        {/*(<Text style={{fontWeight:300, fontSize: "13px" , marginBottom: "13px"}}> No contact details available for the selected country</Text>) */}
      </div>
      
      {/* Display orgDetails for the selected country */}
      {selectedCountry?.text && selectedCountry.text.toLowerCase() !=="global" && (
        <>
          <Text weight = "semibold" style={{fontSize:"13px"}}>Org Details - {selectedCountry.text}: <br /> </Text>
          {orgItems.length>0?(
          <Accordion collapsible>
            {orgItems.map((item,index)=>(
              <AccordionItem key={index} value={index} onClick={()=>handleSubOrgFetch(item.orgObjectID)}>
                <AccordionHeader style={{fontSize:"13px"}} >{item.organisationName}</AccordionHeader>
                <AccordionPanel style={{fontSize:"13px"}}>{
                  actionLoading === item.orgObjectID ? (
                    <Spinner label= "Loading details..." />
                  ): actionItems[item.orgObjectID] &&
                  actionItems[item.orgObjectID].length>0?(
                    <ul className="ml-4 list-disc">
                      {actionItems[item.orgObjectID].map((sub,subIndex) => (
                        <li key={subIndex}>
                          {sub.actionURL ? (
                            <Link href={sub.actionURL} target="_blank">
                              {sub.actionName}
                            </Link>
                          ):(sub.actionName)}
                        </li>
                      ))}
                    </ul>
                  ):(<Text> No action details available. </Text>)
                  }</AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        ):(<Text style={{fontSize:"13px",fontWeight:300, marginBottom: "16px"}}>No Organization results found for the selected country.<br /> <br /></Text>)}
        </>
      )}

      {/* Always show global details */}
      <div className="mt-4">
        <Text weight="semibold" style={{fontSize:"13px"}}>Org Details - Global:</Text>
        <Accordion collapsible>
          {globalData.map((item,idx) => (
            <AccordionItem key={idx} value={idx} onClick={()=>handleSubOrgFetch(item.orgObjectID)}>
              <AccordionHeader style={{fontSize:"13px"}} expandIcon={<ChevronRight20Regular />}>
                {item.organisationName}
              </AccordionHeader>
              <AccordionPanel style={{fontSize:"13px"}}>{
                actionLoading === item.orgObjectID ?(
                  <Spinner label="Loading details... " />
                ) : actionItems[item.orgObjectID] &&
                actionItems[item.orgObjectID].length>0?(
                  <ul className="ml-4 list-disc">
                    {actionItems[item.orgObjectID].map((sub,subIndex) =>(
                      <li key={subIndex}>
                        {sub.actionURL ? (
                          <Link href = {sub.actionURL} target="_blank">
                            {sub.actionName}
                          </Link>
                        ):(sub.actionName)}
                      </li>
                    ))}
                  </ul>
                ):(<Text> No action details available. </Text>
                )
              }</AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
        </div>
      </div>
  );
}
